import {
  getAllWidgets,
  getJSONWidgetDataFromStore,
} from '@/components/WidgetMaker/WidgetDnD/widgetDnDUtils';
import { RegisteredWidget, registerWidget } from '@dotpe/kui/styles/registerWidgetForDnD';
import { generateWidgetData } from 'src/context/WidgetDndContext/WidgetDndContextReducer/WidgetDndContextReducer';
import { PATH } from './routes';
import { StoreDetails } from 'src/redux/reducers';
import { getWebsiteLiveStatus } from './storeSubscriptionConfigs';
import { BUILDER_WIDGET_ROUTES } from 'src/constants/builderConstants';
import { getBasicWebsiteInfoByCTX } from 'src/pageUtils/commonUtils/ctxUtils';
import { appendSlashToUrl } from './appendSlashToUrl';

function getSelectedRouteType({ domain, ctx }) {
  const path = ctx?.req?.url || '/';
  if (path?.includes(appendSlashToUrl(PATH.COLLECTIONS.toLowerCase(), true)))
    return BUILDER_WIDGET_ROUTES.COLLECTION;
  if (path?.includes(appendSlashToUrl(BUILDER_WIDGET_ROUTES.CATEGORY.toLowerCase())))
    return BUILDER_WIDGET_ROUTES.COLLECTION;
  if (path?.includes(appendSlashToUrl(PATH.SHOP, true)))
    return BUILDER_WIDGET_ROUTES.COLLECTION;
  return BUILDER_WIDGET_ROUTES.HOME;
}

const getCustomTemplateWidgets = async (jsonPageWidgetData): Promise<any> => {
  const jsonPageWidgetId = jsonPageWidgetData?.widget_id;

  if (!jsonPageWidgetId) {
    return {
      error: true,
      data: [{}, []],
    };
  }
  const widgetLibraryObj = await getAllWidgets();
  const widgetTemplateLibraryMap = {};
  const widgetTemplateLibraryList = [];

  Object.entries(widgetLibraryObj).forEach(([widgetName, widget]) => {
    if (widgetName !== 'Carousel' && widgetName !== 'Testimonials') {
      const chasisWidget: RegisteredWidget = {
        name: widgetName,
        // component: () => <></>,
        component: null,
        options: widget.manifest?.widgetOptions,
        icon: widget.manifest.icon || null,
        // type: widgetName !== 'Carousel' ? 'template' : 'theme',
        type: 'template',
        thumb: widget.thumb,
        manifest: widget.manifest,
      };
      widgetTemplateLibraryMap[widgetName] = chasisWidget;
      registerWidget(chasisWidget);
    }
  });

  return [widgetTemplateLibraryMap, widgetTemplateLibraryList];
};

export const getWidgetSSRData = async ({
  storeInfo,
  ctx = null,
  domain,
}: {
  storeInfo: StoreDetails;
  ctx: any;
  domain?: string;
}) => {
  const data = {
    widgets: {},
    widgetTemplateLibraryMap: {},
    widgetTemplateLibraryList: [],
    jsonPageWidgetData:
      storeInfo?.theme?.components.Body?.find(
        (widgetData) => widgetData?.name === 'JsonPageWidget'
      ) || null,
    themeComponents: storeInfo?.theme?.components || null,
    globalStyle: storeInfo?.theme?.style || null,
    pageStyle: storeInfo?.theme?.style || null,
  };
  try {
    const selectedRoute = getSelectedRouteType({ domain, ctx });
    const websiteLiveStatus = getWebsiteLiveStatus(storeInfo);
    const basicWebsiteInfoByCTX = getBasicWebsiteInfoByCTX(ctx);

    // These 2 flags are used to know when to call widgets API call
    const isBuilderLevelCall =
      !!storeInfo?.internal_admin_access ||
      basicWebsiteInfoByCTX.isPreviewRoute ||
      basicWebsiteInfoByCTX.isBuilderRoute;

    const isCFELevelCall =
      storeInfo?.theme?.custom_theme_flag ||
      websiteLiveStatus.isNewStoreWebsiteLive ||
      storeInfo?.theme?.brand_website_flag;

    if (isCFELevelCall || isBuilderLevelCall) {
      const response = await getJSONWidgetDataFromStore({
        forRoute: selectedRoute,
        useDefaultStyleFallback: isBuilderLevelCall,
        storeID: storeInfo?.store_id,
        widget_call_status: isBuilderLevelCall ? 2 : 1,
      });
      const {
        widgetsTemplates,
        jsonPageWidgetSchema,
        pageStyle: pageStyles,
        themeComponents: themeComponent,
        storeStyle,
      } = response;
      data.jsonPageWidgetData = jsonPageWidgetSchema;
      data.themeComponents = themeComponent as any;
      data.globalStyle = storeStyle;
      data.pageStyle = pageStyles;
      data.widgets = generateWidgetData(widgetsTemplates);

      const jsonPageWidgetId = data.jsonPageWidgetData?.widget_id;

      if (!jsonPageWidgetId) {
        return {
          error: true,
          errorMessage: 'jsonPageWidgetId not found',
          data,
        };
      }
      const widgetTemplateLibraryData = await getCustomTemplateWidgets(
        data.jsonPageWidgetData
      );
      const [widgetTemplateLibraryMap, widgetTemplateLibraryList] =
        widgetTemplateLibraryData;
      data.widgetTemplateLibraryMap = widgetTemplateLibraryMap;
      data.widgetTemplateLibraryList = widgetTemplateLibraryList;
    }

    return {
      error: false,
      data,
    };
  } catch (error) {
    return {
      error: true,
      errorMessage: error,
      data,
    };
  }
};
